import React from "react";
import { useTranslation } from "react-i18next";

export const Header = (props) => {
  const { t } = useTranslation();

  return (
    <header id="header">
      <div className="intro">
        <div className="intro-bg-slider">
          <div className="intro-bg intro-bg-1"></div>
          <div className="intro-bg intro-bg-2"></div>
          <div className="intro-bg intro-bg-3"></div>
          <div className="intro-bg intro-bg-4"></div>
          <div className="intro-bg intro-bg-5"></div>
        </div>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {t('header.title')}
                  <span></span>
                </h1>
                <p>{t('header.paragraph')}</p>
                <div className="intro-bullets">
                  <div className="bullet-item">
                    <i className="fa fa-check"></i> {t('header.bullets.firstToKnow')}
                  </div>
                  <div className="bullet-item">
                    <i className="fa fa-check"></i> {t('header.bullets.data')}
                  </div>
                  <div className="bullet-item">
                    <i className="fa fa-check"></i> {t('header.bullets.subscription')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
